
import ProductList from '@/manager/product/views/productList.view.vue';
import EmployeeList from '@/manager/employee/views/employeeList.view.vue';
import ClientList from '@/manager/client/views/clientList.view.vue';
// import ClientEdit from '@/manager/client/views/clientEdit/clientEdit.view.vue';
import ClientEdit from '@/manager/client/views/clientEdit/clientList.view.vue';
import ConvocationList from '@/manager/convocation/views/convocationList.view.vue';
import ConvocationDetail from '@/manager/convocation/views/convocationDetail/convocationDetail.view.vue';
import SyncDetail from '@/manager/sync/views/syncDetail/syncDetail.view.vue';
import Settings from '@/manager/settings/views/settings.view.vue';
import PurchaseConvocationList from '@/manager/purchase/views/convocation-list/index.vue';
import PurchaseConvocationDetail from '@/manager/purchase/views/convocation-detail/index.vue';
import BudgetList from '@/manager/budget/views/budget-list/index.vue';
import BillingList from '@/manager/billing/views/bill-list/index.vue';

import middlewares from '@/core/services/routeMiddlewares.service';
import ManagerLayout from '@/manager/manager.layout.vue';

import RouteNames from '@/constants/route-names';


const ManagerRouter = {
  path: '/app/',
  component: ManagerLayout,
  name: 'app',
  beforeEnter: middlewares.ifAuthenticated,
  redirect: { name: RouteNames.ConvocationList },
  children: [{
    path: 'product',
    name: RouteNames.ProductList,
    component: ProductList,
  }, {
    path: 'employee',
    name: RouteNames.EmployeeList,
    component: EmployeeList,
  }, {
    path: 'client',
    name: RouteNames.ClientList,
    component: ClientList,
  },  {
    path: 'client/:id',
    name: RouteNames.ClientEdit,
    props: true,
    component: ClientEdit,
  }, {
    path: 'convocation',
    name: RouteNames.ConvocationList,
    component: ConvocationList,
    beforeEnter: middlewares.cleanConvocationList,
  }, {
    path: 'convocation/:id',
    name: RouteNames.ConvocationDetail,
    props: true,
    component: ConvocationDetail,
  }, {
    path: 'sync',
    name: RouteNames.SyncDetail,
    component: SyncDetail,
  }, {
    path: 'settings',
    name: RouteNames.Settings,
    component: Settings,
  }, {
    path: 'purchase/convocation',
    name: RouteNames.PurchaseConvocationList,
    component: PurchaseConvocationList,
  }, {
    path: 'purchase/convocation/:id',
    name: RouteNames.PurchaseConvocationDetail,
    props: true,
    component: PurchaseConvocationDetail,
  }, {
    path: 'budget',
    name: RouteNames.BudgetList,
    component: BudgetList,
  }, {
    path: 'budget/:id',
    name: RouteNames.BudgetName,
    component: BudgetList,
  }, {
    path: 'billing',
    name: RouteNames.BillList,
    component: BillingList,
  }, 
]};


export default [
  ManagerRouter,
];
